import { formatDecimal } from '@/utils/numberFormat';

export interface FormatAverageInput {
    /** The value to render, on the `1..scale` proficiency scale. */
    average: number;
    /** Number of proficiency levels the company has configured (`report.levels.length`). */
    scale: number;
    /** Application language, so the decimal separator follows it. */
    language: string;
}

/**
 * Formats a report average as "3,9 / 5" (fr) or "3.9 / 5" (en).
 *
 * Takes an object rather than positional arguments: `average` and `scale` are both `number`, so a
 * swapped call site would compile and ship silently.
 */
export const formatAverage = ({ average, scale, language }: FormatAverageInput): string =>
    `${formatDecimal(average, language)} / ${scale}`;
